var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIOsDeviceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 36,
    rx: 4,
    fill: "#2855BF",
    fillOpacity: 0.15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 35,
    height: 35,
    rx: 3.5,
    stroke: "#2855BF",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6445 14.31C16.9145 14.31 15.7845 13.48 14.5945 13.51C13.0245 13.53 11.5845 14.42 10.7745 15.83C9.14448 18.66 10.3545 22.84 11.9445 25.14C12.7245 26.26 13.6445 27.52 14.8645 27.48C16.0345 27.43 16.4745 26.72 17.8945 26.72C19.3045 26.72 19.7045 27.48 20.9445 27.45C22.2045 27.43 23.0045 26.31 23.7745 25.18C24.6645 23.88 25.0345 22.62 25.0545 22.55C25.0245 22.54 22.6045 21.61 22.5745 18.81C22.5545 16.47 24.4845 15.35 24.5745 15.3C23.4745 13.69 21.7845 13.51 21.1945 13.47C19.6545 13.35 18.3645 14.31 17.6445 14.31ZM20.2445 11.95C20.8945 11.17 21.3245 10.08 21.2045 9C20.2745 9.04 19.1545 9.62 18.4845 10.4C17.8845 11.09 17.3645 12.2 17.5045 13.26C18.5345 13.34 19.5945 12.73 20.2445 11.95Z",
    fill: "#2855BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIOsDeviceIcon);
export default __webpack_public_path__ + "static/media/iOSDeviceIcon.8c546a81.svg";
export { ForwardRef as ReactComponent };